import api from './axiosConfig';

interface LoginCredentials {
  email: string;
  password: string;
}

interface RegisterData extends LoginCredentials {
  name: string;
  phone: string;
  country: string;
}

interface User {
  id: string;
  name: string;
  email: string;
  role: string;
}

interface AuthResponse {
  token: string;
  user: User;
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await api.post<{ data: AuthResponse }>('/auth/login', credentials);
    if (response?.data?.data?.token) {
      localStorage.setItem('token', response.data.data.token);
    }
    return response.data.data;
  },

  async register(data: RegisterData): Promise<AuthResponse> {
    const response = await api.post<{ data: AuthResponse }>('/auth/register', data);
    if (response?.data?.data?.token) {
      localStorage.setItem('token', response.data.data.token);
    }
    return response.data.data;
  },

  logout(): void {
    localStorage.removeItem('token');
  },

  getCurrentUser(): User | null {
    const token = localStorage.getItem('token');
    if (!token) return null;
    
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      const payload = JSON.parse(jsonPayload);
      return {
        id: payload.id,
        name: payload.name,
        email: payload.email,
        role: payload.role
      };
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  },

  async forgotPassword(email: string): Promise<void> {
    await api.post('/auth/forgot-password', { email });
  },

  async resetPassword(token: string, userId: string, password: string): Promise<void> {
    await api.post('/auth/reset-password', { token, userId, password });
  },

  async resetGuestPassword(token: string, userId: string, password: string): Promise<void> {
    await api.post('/auth/guest-reset-password', { token, userId, password });
  },

  async getCurrentUserFromServer(): Promise<User> {
    const response = await api.get<{ data: User }>('/auth/whoami');
    return response.data.data;
  }
}; 